var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expand",
    transform: "translate(-178.611 -658.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10893",
    "data-name": "Rectangle 10893",
    width: 9.339,
    height: 9.339,
    transform: "translate(180 659.885)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16798",
    "data-name": "Path 16798",
    d: "M189.286,678.714H200A1.383,1.383,0,0,1,198.714,680h-9.429A1.383,1.383,0,0,1,188,678.714h0v-9.428h1.286ZM200,674.857h-1.286v3.857H200ZM200,668v4.286h-1.26V670.18l-4.535,4.535-.92-.92,4.509-4.509h-2.08V668Zm-10.714,0h3.857v1.286H188A1.383,1.383,0,0,1,189.286,668Z",
    transform: "translate(-9.389 -9.388)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMap);
export default __webpack_public_path__ + "static/media/expand-map.76b47031.svg";
export { ForwardRef as ReactComponent };